@if ((dataVisible$ | async)) {
  @if (aftrekbarePremiesTotaal > 0) {
    <form [formGroup]="formGroup">
      @if (formGroup.controls.aftrekbareLijfrentePremie.value !== null) {
        <div class="row">
          <div class="col col-1">
            <p>Aftrekbare premie lijfrente</p>
          </div>
          <div class="col-2"></div>
          <div class="col-2"></div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="aftrekbareLijfrentePremie"
              id="aftrekbareLijfrentePremie"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2"></div>
        </div>
      }
      @if (formGroup.controls.premieAovVerzekering.value !== null) {
        <div class="row">
          <div class="col col-1">
            <p>Aftrekbare premie AOV</p>
          </div>
          <div class="col-2"></div>
          <div class="col-2"></div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="premieAovVerzekering"
              id="premieAovVerzekering"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2"></div>
        </div>
      }
      @if (formGroup.controls.premieAnwVerzekering.value !== null) {
        <div class="row">
          <div class="col col-1">
            <p>Premie nabestaandenverzekering</p>
          </div>
          <div class="col-2"></div>
          <div class="col-2"></div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="premieAnwVerzekering"
              id="premieAnwVerzekering"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2 "></div>
        </div>
      }
      @if (formGroup.controls.lijfrenteVoorKind.value !== null) {
        <div class="row">
          <div class="col col-1">
            <p>Premie verzekering meerderjarig invalide kind(eren)</p>
          </div>
          <div class="col-2"></div>
          <div class="col-2"></div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="lijfrenteVoorKind"
              id="lijfrenteVoorKind"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2"></div>
        </div>
      }
      @if (formGroup.controls.saldoNegatievePremiesInkomensvoorzieningen.value !== undefined) {
        <div class="row">
          <div class="col col-1">
            Negatieve premies inkomensvoorzieningen
          </div>
          <div class="col-2"></div>
          <div class="col-2"></div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="saldoNegatievePremiesInkomensvoorzieningen"
                                              id="saldoNegatievePremiesInkomensvoorzieningen"
                                              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2"></div>
        </div>
      }
      <div class="row">
        <div class="col col-1">
          <b>Premies inkomensvoorzieningen</b>
        </div>
        <div class="col-2"></div>
        <div class="col-2"></div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            [calculate]="calculateAftrekbarePremies()"
            align="right"
            class="custom-input-150"
            formControlName="saldoPremiesInkomensvoorzieningen"
            id="saldoPremiesInkomensvoorzieningen"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-2"></div>
      </div>
    </form>

    <form [formGroup]="formGroup">
      <div>
        <p class="pt-3"><b>Jaar- en reserveringsruimte</b></p>
        <div class="row">
          <div class="col col-1 pt-3">
            Jaarruimte {{ this.year }}
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="jaarruimte"
                                              id="jaarruimte"
                                              label="Berekende ruimte"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
<!--          <div class="col-2">-->
<!--            <snelstart-ui-number-form-control [decimals]="0"-->
<!--                                              align="right"-->
<!--                                              class="custom-input-150"-->
<!--                                              formControlName="emptyField"-->
<!--                                              id="benutteJaarruimte"-->
<!--                                              label="Reeds eerder benut"-->
<!--                                              prefix="€"-->
<!--            ></snelstart-ui-number-form-control>-->
<!--          </div>-->
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="benutteJaarrruimte"
                                              id="benutteJaarruimte"
                                              label="Dit jaar benut"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="resterendeJaarruimte"
                                              id="resterendeJaarruimte"
                                              label="Resteert"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-2 "></div>
        </div>
      </div>
      @if (hasReserveringsruimte()) {
        @for (jaar of ruimteJaren; track jaar.offset) {
          @if (hasReserveringsruimteVoorJaar(jaar.offset)) {
            <div class="left">
              <div class="row">
                <div class="col col-1">
                  Reserveringsruimte {{ year - jaar.offset }}
                </div>
                <div class="col-2 bold">
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [formControlName]="'reserveringsruimte' + jaar.suffix"
                                                    align="right"
                                                    class="custom-input-150"
                                                    prefix="€"
                  ></snelstart-ui-number-form-control>
                </div>
<!--                <div class="col-2 bold">-->
<!--                  <snelstart-ui-number-form-control [decimals]="0"-->
<!--                                                    [formControlName]="'alGebruikteRuimte' + jaar.suffix"-->
<!--                                                    align="right"-->
<!--                                                    class="custom-input-150"-->
<!--                                                    prefix="€"-->
<!--                  ></snelstart-ui-number-form-control>-->
<!--                </div>-->
                <div class="col-2">
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [formControlName]="'benutteReserveringsruimte' + jaar.suffix"
                                                    align="right"
                                                    class="custom-input-150"
                                                    prefix="€"
                  ></snelstart-ui-number-form-control>
                </div>
                <div class="col-2">
                  <snelstart-ui-number-form-control [decimals]="0"
                                                    [formControlName]="'resterendeReserveringsruimte' + jaar.suffix"
                                                    align="right"
                                                    class="custom-input-150"
                                                    prefix="€"
                  ></snelstart-ui-number-form-control>
                </div>
                <div class="col-2"></div>
              </div>
            </div>
          }
        }
        @if ((formGroup.controls.reserveringsruimte.value ?? 0) <= (formGroup.controls.benutteReserveringsruimte.value ?? 0)) {
          <div class="left">
            <div class="row">
              <div class="col col-1">Maximale reserveringsruimte</div>
              <div class="col col-2"></div>
              <div class="col col-2"></div>
              <div class="col col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="reserveringsruimte"
                  id="Reserveringsruimte"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col col-2"></div>
              <div class="col-2"></div>
            </div>
          </div>
        }
        @if (formGroup.controls.benutteReserveringsruimte.value !== null) {
          <div class="left">
            <div class="row pt-2">
              <div class="col col-1 bold">Totaal</div>
              <div class="col-2"></div>
              <div class="col-2"></div>
              <div class="col-2 ps-5">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="aftrekbareLijfrentePremie"
                  id="aftrekbareLijfrentePremie2"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="resterendeTotaleRuimte"
                  id="resterendeTotaleRuimte"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          </div>
        }
      }
    </form>
  } @else {
    <p>Er zijn geen aftrekbare premies voor inkomensvoorzieningen gevonden in de aangifte.</p>
  }
}
